import axiosService from './axios.service';
import ResponseService from './response.service';

const initiateKyc = async () => {
  try {
    let axiosData = {
      method: 'post',
      url: 'kyc/initiate',
      isAuthorized: true,
      formData: {},
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const checkKycProgress = async (_formData) => {
  try {
    let axiosData = {
      method: 'get',
      url: `kyc/${_formData.id}`,
      isAuthorized: true,
      formData: _formData,
      params: {
        ...(_formData.trackRealtimeStatus ? { trackRealtimeStatus: 1 } : {}),
      },
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const KycService = {
  initiateKyc,
  checkKycProgress,
};

export default KycService;
